/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

// 校验名称 只可输入中英文与字母与数字
export const validateUserName = (rule, value, callback) => {
  const pattern = new RegExp(
    /^[\u4e00-\u9fa5-_a-zA-Z0-9\uff1f\uff01\u3002\.\?\!]+$/
  );
  if (!value) {
    callback(new Error('名称不能为空'));
  } else if (!pattern.test(value)) {
    callback(new Error('不能包含特殊字符'));
  } else {
    callback();
  }
};

// 校验数字
export const validateNumber = (rule, value, callback) => {
  const pattern = new RegExp(/(^[1-9]\d*$)/);
  if (!pattern.test(value)) {
    callback(new Error('请输入正确的数字'));
    return false;
  } else {
    callback();
  }
};

// 校验手机号码
export const validatePhone = (rule, value, callback) => {
  const pattern = new RegExp(/^1\d{10}$/);
  if (!value) {
    callback(new Error('手机号不能为空'));
  } else if (!pattern.test(value)) {
    callback(new Error('请输入正确的手机号码'));
    return false;
  } else {
    callback();
  }
};
// 校验邮箱
export const validateEmail = (rule, value, callback) => {
  const pattern = new RegExp(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/);
  if (value && !pattern.test(value)) {
    callback(new Error('请输入正确的邮箱'));
    return false;
  } else {
    callback();
  }
};

